import { render, staticRenderFns } from "./MedicineWidget.vue?vue&type=template&id=a382c4ca&scoped=true&"
import script from "./MedicineWidget.vue?vue&type=script&lang=js&"
export * from "./MedicineWidget.vue?vue&type=script&lang=js&"
import style0 from "./MedicineWidget.vue?vue&type=style&index=0&id=a382c4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a382c4ca",
  null
  
)

export default component.exports